import { ProviderImportJob } from '../../models/Entities/ProviderConsumptionImport/ProviderConsumptionImport';

/** Aviso global de las importaciones en segundo plano (spec 008). */

export const IMPORT_JOBS_INIT = 'IMPORT_JOBS_INIT';
export const IMPORT_JOBS_TRACK = 'IMPORT_JOBS_TRACK';
export const IMPORT_JOBS_UPDATED = 'IMPORT_JOBS_UPDATED';
export const IMPORT_JOBS_FOREGROUND = 'IMPORT_JOBS_FOREGROUND';
export const IMPORT_JOBS_NOTICE_DONE = 'IMPORT_JOBS_NOTICE_DONE';
export const IMPORT_JOBS_POLLING = 'IMPORT_JOBS_POLLING';

/** Arranque del watcher: ids ya avisados (sessionStorage) e inicio de la sesión de avisos. */
export interface ImportJobsInitAction {
  type: typeof IMPORT_JOBS_INIT;
  notifiedIds: string[];
  sessionSince: string;
}

/** Seguir un job (iniciado acá, seguido por un 409 o visto en la grilla). `notify` = avisar cuando termine. */
export interface ImportJobsTrackAction {
  type: typeof IMPORT_JOBS_TRACK;
  job: ProviderImportJob;
  notify: boolean;
}

/** Resultado de una consulta. `notify` = vienen de `mine` (del usuario: se avisan al terminar). */
export interface ImportJobsUpdatedAction {
  type: typeof IMPORT_JOBS_UPDATED;
  jobs: ProviderImportJob[];
  notify: boolean;
}

/** El job se está mostrando en el asistente abierto (su fin no se avisa con un toast). */
export interface ImportJobsForegroundAction {
  type: typeof IMPORT_JOBS_FOREGROUND;
  jobId: string;
  foreground: boolean;
}

/** El fin del job ya se avisó (toast, notificación o el propio asistente). */
export interface ImportJobsNoticeDoneAction {
  type: typeof IMPORT_JOBS_NOTICE_DONE;
  jobId: string;
}

export interface ImportJobsPollingAction {
  type: typeof IMPORT_JOBS_POLLING;
  polling: boolean;
}

export type ImportJobsKnownAction =
  | ImportJobsInitAction
  | ImportJobsTrackAction
  | ImportJobsUpdatedAction
  | ImportJobsForegroundAction
  | ImportJobsNoticeDoneAction
  | ImportJobsPollingAction;
